import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import { PrismIconComponent, PrismNavButtonComponent, PrismNavGroupComponent } from '@shure/prism-angular-components';

import { MyAccountSideNavComponent } from './my-account-side-nav.component';

@NgModule({
	declarations: [MyAccountSideNavComponent],
	exports: [MyAccountSideNavComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		RouterModule,
		TranslocoModule,
		PrismIconComponent,
		PrismNavGroupComponent,
		PrismNavButtonComponent
	]
})
export class MyAccountSideNavModule {}
